import Axios from "axios"

export interface Platform {
  id: string
  name: string
}

export interface Plan {
  id: string
  name: string
  dataDate: string
  files: Array<string>
  platform: Platform
  superScoreClient: boolean
}

export interface Company {
  id: string
  name: string
  plan: Plan
}

export interface Member {
  id: string
  login: string
  firstname: string
  surname: string
  companyId: string
  companyName: string
  balance: number
  assetBalances: Array<AssetBalance>
}

export interface Asset {
  id: string
  name: string
  description: string
}

export interface AssetBalance {
  asset: string
  balance: number
}

export class PlanService {
  current: Plan | null = null
  engagedOnly = false

  async load(): Promise<void> {
    if (this.current == null) {
      return this.apply("/api/plan")
    }
  }

  async get(planId: string): Promise<void> {
    return this.apply(`/api/plan/${planId}`)
  }

  getPlanFromSessionStorage(): any {
    return JSON.parse(<string>sessionStorage.getItem("currentPlan"))
  }

  removePlanFromSessionStorage(): void {
    window.sessionStorage.removeItem("currentPlan")
  }

  savePlanToSessionStorage(plan: Plan): void {
    this.removePlanFromSessionStorage()
    window.sessionStorage.setItem("currentPlan", JSON.stringify(plan))
  }

  reset(): void {
    this.current = null
  }

  async getFlyer(name: string): Promise<void> {
    if (this.current != null) {
      const flyer = await Axios.get(
        `/api/plan/download/${name}.pdf?planId=${this.current.id}`,
        {responseType: "blob"}
      )
      const url = window.URL.createObjectURL(new Blob([flyer.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `${name}.pdf`)
      document.body.append(link)
      link.click()
      link.remove()
    }
  }

  async getData(): Promise<void> {
    if (this.current != null) {
      const spreadsheet = await Axios.get(
        `/api/plans/${this.current.id}/analyticsSummaryCsv`,
        {
          responseType: "blob",
        }
      )
      const url = window.URL.createObjectURL(new Blob([spreadsheet.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `${this.current.name}.xlsx`)
      document.body.append(link)
      link.click()
      link.remove()
    }
  }

  private async apply(url: string): Promise<void> {
    return Axios.get(url)
      .then(response => {
        this.current = response.data
        this.savePlanToSessionStorage(this.current!)
      })
      .catch(error => {
        console.log(error.message)
      })
  }
}
